export const statusColors = {
  scheduled: '#F29F85',
  ontheway: '#7CD9BE',
  inprogress: '#F5C26B',
  completed: '#6EC173',
  cancelled: '#E2726E',
  pending: '#F9D179',
  reported: '#6FBED8',
  approved: '#4CB78F',
  rejected: '#D87070',
  unverified: '#F28C8C',
  verified: '#6EC173',
  draft: '#B2B2FF',
  default: '#DADADA',
  review: '#F9D179',
  inspection: '#6FBED8',
  resolved: '#6EC173',
  closed: '#B2B2FF',
  installed: '#7CD9BE',
  inStorage: '#B2B2FF',
  repair: '#F5C26B',
  retired: '#E2726E',
  discarded: '#D87070',
  lost: '#F28C8C',   
  active: '#4CB78F',
  maintenance: '#F5C26B',
  outOfService: '#E2726E',
  decommissioned: '#D87070'
};